<template>
  <div class=""
    v-bind:style="{
      fontFamily: globalFont
    }">
    {{ error_message }}<br />
    <div v-if="error_code && error_message !== ''" class="error-code-container">
      [ERROR {{ error_code }}]
    </div>
  </div>
</template>

<script>
import { Cart } from '@/store/Cart'

export default {
  name: 'KpaymentMessages',
  data () {
    return {
      error_message: '',
      error_code: '',
    }
  },
  props: {
    message: {
      type: String,
      default: ''
    },
    locale: {
      type: String,
      default: 'en'
    },
    error: {
      type: String,
      default: ''
    },
  },
  computed: {
    t () {
      if (this.locale == 'en') {
        return {
          card_issues: 'Refer to Card Issuer',
          insufficient_funds: 'Insufficient Funds',
          qr_expired: 'QR code expired',
          error_occured_try_again: 'Error occured! Please try again later.'
        }
      } else if (this.locale == 'th') {
        return {
          card_issues: 'กรุณาติดต่อผู้ออกบัตรของท่าน',
          insufficient_funds: 'วงเงินของบัตรไม่เพียงพอ',
          qr_expired: 'คิวอาร์โค้ดหมดอายุ',
          error_occured_try_again: 'เกิดข้อผิดพลาด! โปรดลองใหม่ภายหลัง'
        }
      } else if (this.locale == 'vi') {
        return {
          card_issues: 'Refer to Card Issuer',
          insufficient_funds: 'Insufficient Funds',
          qr_expired: 'QR code expired',
          error_occured_try_again: 'Xảy ra lỗi! Vui lòng thử lại sau'
        }
      }
    },
    globalFont () {
      return Cart.getGlobalFont()
    }
  },
  created () {
    this.error_code = '02'

    if (String(this.message) === '01') {
      this.error_message = this.t.card_issues
    } else if (String(this.message) === '51') {
      this.error_message = this.t.insufficient_funds
    } else if (this.message === 'qr_expired') {
      this.error_message = this.t.qr_expired
    } else {
      if (this.error === '11') {
        this.error_code = false
        this.error_message = this.message
      } else {
        this.error_code = '03'
        if (this.message === Cart.t.discountPriceChanges) {
          this.error_message = this.message
        } else {
          this.error_message = this.t.error_occured_try_again
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.error-code-container {
  text-align: center;
  font-size: 0.6em;
}
</style>


// WEBPACK FOOTER //
// src/components/share/KpaymentMessages.vue